export enum LoadingState {
  Empty = 'Empty',
  Pending = 'Pending',
  Success = 'Success',
  Failure = 'Failure',
}
